<template>
  <v-container
    id="dashboard-view"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        v-for="(chart, i) in charts"
        :key="`chart-${i}`"
        cols="12"
        lg="6"
      >
        <material-chart-card
          :color="chart.color"
          :data="chart.data"
          :options="chart.options"
          :responsive-options="chart.responsiveOptions"
          :title="chart.title"
          :type="chart.type"
        >
          <template #subtitle>
            <div class="font-weight-light text--secondary">
              <div v-html="chart.subtitle" />
            </div>
          </template>
        </material-chart-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="<material-stat-card"
        cols="12"
        v-bind="monthStat"
      >
        <div class="text--h4 text-center">
          تراز آخرین ماه
        </div>
        <material-stat-card v-bind="monthStat">
          <template #subtitle>
            <v-row>
              <v-col
                cols="6"
                md="3"
              >
                <div
                  style="cursor:pointer"
                  @click="viewLastMonthInstallments"
                >
                  <h4 class="text-h4">
                    اقساط
                  </h4>
                  <div class="text-h4 v-card__subtitle--material-stats">
                    {{ monthStat.monthInstallments.toString().toPriceFormat() }} ریال
                  </div>
                  <div>{{ monthStat.monthInstallmentsCounts }} مورد</div>
                </div>
              </v-col>
              <v-col
                cols="6"
                md="3"
              >
                <div
                  style="cursor:pointer"
                  @click="viewLastMonthSavedMonies"
                >
                  <h4 class="text-h4">
                    پس اندازها
                  </h4>
                  <div class="text-h4 v-card__subtitle--material-stats">
                    {{ monthStat.monthSaveds.toString().toPriceFormat() }} ریال
                  </div>
                  <div>{{ monthStat.monthSavedsCounts }} مورد</div>
                </div>
              </v-col>
              <v-col
                cols="6"
                md="3"
              >
                <h4 class="text-h4">
                  وام ها
                </h4>
                <div
                  class="text-h4 v-card__subtitle--material-stats"
                >
                  {{ monthStat.monthLoans.toString().toPriceFormat() }} ریال
                </div>
              </v-col>
              <v-col
                cols="6"
                md="3"
              >
                <h4 class="text-h4">
                  موجودی صندوق
                </h4>
                <div
                  class="text-h4 v-card__subtitle--material-stats"
                  :class="[monthStat.monthBalance < 0 ? 'red--text' : 'green--text']"
                >
                  {{ monthStat.monthBalance.toString().toPriceFormat() }} <br> ریال
                </div>
              </v-col>
            </v-row>
          </template>
          <template #actions>
            <v-icon
              class="mr-2"
              small
              v-text="monthStat.actionIcon"
            />
            <div
              class="text-truncate"
              v-html="monthStat.actionText"
            />
          </template>
        </material-stat-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="({ actionIcon, actionText, ...attrs }, i) in stats"
        :key="i"
        cols="12"
        md="6"
        lg="3"
      >
        <material-stat-card v-bind="attrs">
          <template #actions>
            <v-icon
              class="mr-2"
              small
              v-text="actionIcon"
            />
            <div
              class="text-truncate"
              v-html="actionText"
            />
          </template>
        </material-stat-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="<material-stat-card"
        cols="12"
        v-bind="expenseStat"
      >
        <material-stat-card v-bind="expenseStat">
          <template #subtitle>
            <v-row>
              <v-col
                cols="6"
                md="3"
              >
                <div>
                  <h4 class="text-h4">
                    1 درصد سهم صندوق
                  </h4>
                  <div class="text-h4 v-card__subtitle--material-stats">
                    {{ expenseStat.costShare.toString().toPriceFormat() }} ریال
                  </div>
                </div>
              </v-col>
              <v-col
                cols="6"
                md="3"
              >
                <div>
                  <h4 class="text-h4">
                    هزینه ها
                  </h4>
                  <div class="text-h4 v-card__subtitle--material-stats">
                    {{ expenseStat.expense.toString().toPriceFormat() }} ریال
                  </div>
                </div>
              </v-col>
              <v-col
                cols="6"
                md="3"
              >
                <h4 class="text-h4">
                  مانده
                </h4>
                <div
                  class="text-h4 v-card__subtitle--material-stats"
                  :class="[expenseStat.remain < 0 ? 'red--text' : 'green--text']"
                >
                  {{ expenseStat.remain.toString().toPriceFormat() }} ریال
                </div>
              </v-col>
            </v-row>
          </template>
          <template #actions>
            <v-icon
              class="mr-2"
              small
              v-text="expenseStat.actionIcon"
            />
            <div
              class="text-truncate"
              v-html="expenseStat.actionText"
            />
          </template>
        </material-stat-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="6"
      >
        <material-stat-card v-bind="stats2.checkoutedThisMonth">
          <template #subtitle>
            <v-row>
              <v-col
                cols="12"
              >
                <router-link :to="'/admin/checkoutThisMonth'">
                  <h4 class="text-h4">
                    تعداد اعضایی که این ماه تسویه شده اند
                  </h4>
                  <div class="text-h4 v-card__subtitle--material-stats">
                    {{ stats2.checkoutedThisMonth.value }} نفر
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </template>
        </material-stat-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="6"
      >
        <material-stat-card v-bind="stats2.allCheckouted">
          <template #subtitle>
            <v-row>
              <v-col
                cols="12"
              >
                <router-link :to="'/admin/checkoutedMembers'">
                  <h4 class="text-h4">
                    تعداد اعضایی که در مجموع تسویه شده اند
                  </h4>
                  <div class="text-h4 v-card__subtitle--material-stats">
                    {{ stats2.allCheckouted.value }} نفر
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </template>
        </material-stat-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="6"
      >
        <material-card
          color="orange"
          full-header
        >
          <template #heading>
            <div class="pa-8 white--text">
              <div class="text-h4 font-weight-light">
                لیست آخرین نفرات مراجعه کننده به پنل
              </div>
              <div class="text-caption">
                لیست آخرین مراجعه کنندگانی که به پنل کاربری خود مراجعه کرده اند
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="lastLoginHeaders"
              :items="lastLoginItems"
            />
          </v-card-text>
        </material-card>
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <material-card
          color="red"
          full-header
        >
          <template #heading>
            <div class="pa-8 white--text">
              <div class="text-h4 font-weight-light">
                لیست درخواست وام های جدید
              </div>
              <div class="text-caption">
                لیست اعضایی که درخواست وام دارند
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="newLoanRequestHeaders"
              :items="newLoanRequestItems"
            />
          </v-card-text>
        </material-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogLastMonthInstallments"
      max-width="1100px"
    >
      <v-card>
        <v-card-title>
          <div><span class="headline">لیست اقساط</span></div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <installments-by-month
              ref="installments"
              :date="lastMonthPersianDate"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="dialogLastMonthInstallments = false"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogLastMonthSavedMonies"
      max-width="1100px"
    >
      <v-card>
        <v-card-title>
          <div><span class="headline">لیست پس اندازها</span></div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <saved-monies-by-month
              ref="savedMonies"
              :date="lastMonthPersianDate"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="dialogLastMonthSavedMonies = false"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'
  import Vue from 'vue'
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import InstallmentsByMonth from './InstallmentsByMonth'
  import SavedMoniesByMonth from './SavedMoniesByMonth'

  const lineSmooth = Vue.chartist.Interpolation.cardinal({
    tension: 0,
  })

  export default {
    name: 'DashboardView',
    components: { InstallmentsByMonth, SavedMoniesByMonth },

    data: () => ({
      charts: {
        loan: {
          type: 'Line',
          color: 'success',
          title: 'آمار وام های جدید',
          subtitle: 'نمودار مجموع وام های اعطا شده در یکسال گذشته ',
          data: {
            labels: [],
            series: [
              [],
            ],
          },
          options: {
            lineSmooth,
            low: 0,
            high: 100000000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
            axisY: {
              offset: 90,
              labelInterpolationFnc: function (value) {
                return value.toString().toPriceFormat()
              },
            },
          },
        },
        payment: {
          type: 'Line',
          color: 'info',
          title: 'آمار اقساط',
          subtitle: 'نمودار مجموع اقساط ثبت شده در یکسال گذشته ',
          data: {
            labels: [],
            series: [[]],
          },
          options: {
            lineSmooth,
            low: 0,
            high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
            axisY: {
              offset: 90,
              labelInterpolationFnc: function (value) {
                return value.toString().toPriceFormat()
              },
            },
          },
        },
      },
      lastLoginHeaders: [
        {
          sortable: false,
          text: 'نام',
          value: 'fullName',
        },
        {
          sortable: false,
          text: 'کد پرسنلی',
          value: 'personalCode',
          align: 'right',
        },
        {
          sortable: false,
          text: 'آخرین فعالیت',
          value: 'lastLoginDate',
          align: 'center',
        },
      ],
      lastLoginItems: [],
      newLoanRequestItems: [],
      newLoanRequestHeaders: [
        {
          sortable: false,
          text: 'نام',
          value: 'memberModel.fullName',
        },
        {
          sortable: false,
          text: 'کد پرسنلی',
          value: 'memberModel.personalCode',
          align: 'right',
        },
        {
          sortable: false,
          text: 'نوع وام',
          value: 'loanModel.title',
          align: 'right',
        },
        {
          sortable: false,
          text: 'مبلغ',
          value: 'amount',
          align: 'center',
        },
        {
          sortable: false,
          text: 'تاریخ درخواست',
          value: 'requestDate_Persian.date',
          align: 'center',
        },
      ],
      monthStat: {
        actionIcon: 'mdi-calendar',
        actionText: '',
        color: '#FD9A13',
        icon: 'mdi-scale-balance',
        title: '',
        value: '',
        monthInstallments: 0,
        monthInstallmentsCounts: 0,
        monthSaveds: 0,
        monthSavedsCounts: 0,
        monthLoans: 0,
        monthBalance: 0,
      },
      stats: {
        loans: {
          actionIcon: 'mdi-tag',
          actionText: 'مجموع کل مبلغ وام های اعطا شده',
          color: 'primary',
          icon: 'mdi-account-cash',
          title: 'مجموع وام ها',
          value: '',
        },
        paids: {
          actionIcon: 'mdi-tag',
          actionText: 'مجموع کل مبلغ اقساط پرداخت شده',
          color: 'success',
          icon: 'mdi-cash-check',
          title: 'مجموع اقساط پرداختی',
          value: '',
        },
        unpaids: {
          actionIcon: 'mdi-tag',
          actionText: 'مبلغ کل باقیمانده اقساط',
          color: 'info',
          icon: 'mdi-cash-remove',
          title: 'مجموع باقیمانده ها',
          value: '',
        },
        saved: {
          actionIcon: 'mdi-tag',
          actionText: 'مجموع پس انداز های موجود صندوق',
          color: 'info',
          icon: 'mdi-cash-multiple',
          title: 'مجموع پس انداز ها',
          value: '',
        },
      },
      expenseStat: {
        actionIcon: 'mdi-tag',
        actionText: 'مجموع 1 درصد از وام ها بابت هزینه های صندوق',
        color: 'info',
        icon: 'mdi-flower-tulip',
        title: '',
        value: '',
        costShare: 0,
        expense: 0,
        remain: 0,
      },
      stats2: {
        checkoutedThisMonth: {
          actionIcon: 'mdi-tag',
          actionText: '',
          color: 'primary',
          icon: 'mdi-account-cash',
          title: '',
          value: '',
        },
        allCheckouted: {
          actionIcon: 'mdi-tag',
          actionText: '',
          color: 'info',
          icon: 'mdi-account-cash',
          title: '',
          value: '',
        },
      },
      tabs: 0,
      tasks: {
        0: [
          {
            text: 'Sign contract for "What are conference organizers afraid of?"',
            value: true,
          },
          {
            text: 'Lines From Great Russian Literature? Or E-mails From My Boss?',
            value: false,
          },
          {
            text: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
            value: false,
          },
          {
            text: 'Create 4 Invisible User Experiences you Never Knew About',
            value: true,
          },
        ],
        1: [
          {
            text: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
            value: true,
          },
          {
            text: 'Sign contract for "What are conference organizers afraid of?"',
            value: false,
          },
        ],
        2: [
          {
            text: 'Lines From Great Russian Literature? Or E-mails From My Boss?',
            value: false,
          },
          {
            text: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
            value: true,
          },
          {
            text: 'Sign contract for "What are conference organizers afraid of?"',
            value: true,
          },
        ],
      },
      dialogLastMonthInstallments: false,
      dialogLastMonthSavedMonies: false,
      lastMonthPersianDate: '',
    }),

    computed: {
      sales: get('sales/sales'),
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
    },

    mounted () {
      this.loadData()
      this.getLastLoginMembers()
      this.getNewLoanRequests()
    },
    methods: {
      getLastLoginMembers () {
        api.get('admin/dashboard/getLastLoginMembers', null)
          .then(
            response => {
              this.lastLoginItems = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      getNewLoanRequests () {
        api.get('admin/UserLoanRequest/GetNewRequests', null)
          .then(
            response => {
              this.newLoanRequestItems = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      loadData () {
        api.get('admin/dashboard/get', null)
          .then(
            response => {
              const loanChartData = { labels: [], series: [] }
              let high1 = 0
              if (response.loanChart) {
                const series = []
                for (let i = 0; i < response.loanChart.length; i++) {
                  loanChartData.labels.push(response.loanChart[i].month)
                  series.push(response.loanChart[i].amount)
                  high1 = Math.max(high1, response.loanChart[i].amount)
                }
                loanChartData.series.push(series)
              }

              const paymentChartData = { labels: [], series: [] }
              let high2 = 0
              if (response.paymentChart) {
                const series = []
                for (let i = 0; i < response.paymentChart.length; i++) {
                  paymentChartData.labels.push(response.paymentChart[i].month)
                  series.push(response.paymentChart[i].amount)
                  high2 = Math.max(high2, response.paymentChart[i].amount)
                }
                paymentChartData.series.push(series)
              }
              this.charts.loan.data = loanChartData
              this.charts.loan.options.high = high1
              this.charts.payment.data = paymentChartData
              this.charts.payment.options.high = high2

              // this.stats.members.value = response.memberCount + '<br/> نفر'
              this.stats.loans.value = response.totalLoans.toString().toPriceFormat() + '<br/> ریال'
              this.stats.paids.value = response.totalPaid.toString().toPriceFormat() + '<br/> ریال'
              this.stats.unpaids.value = response.totalUnpaid.toString().toPriceFormat() + '<br/> ریال'
              this.stats.saved.value = response.totalSave.toString().toPriceFormat() + '<br/> ریال'

              this.stats2.checkoutedThisMonth.value = response.checkoutedThisMonthCount
              this.stats2.allCheckouted.value = response.allCheckoutedCount

              this.monthStat.monthInstallments = response.monthInstallments
              this.monthStat.monthInstallmentsCounts = response.monthInstallmentsCounts
              this.monthStat.monthSaveds = response.monthSaveds
              this.monthStat.monthSavedsCounts = response.monthSavedsCounts
              this.monthStat.monthLoans = response.monthLoans
              this.monthStat.monthBalance = response.monthBalance
              this.monthStat.actionText = `آخرین ماه دریافت شده: ${response.lastMonthPersianDate.monthName} ${response.lastMonthPersianDate.year}`
              this.lastMonthPersianDate = response.lastMonthPersianDate.date

              this.expenseStat.costShare = response.costShare
              this.expenseStat.expense = response.expense
              this.expenseStat.remain = response.costShare - response.expense
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      viewLastMonthSavedMonies () {
        this.dialogLastMonthSavedMonies = true
        this.$nextTick(() => {
          this.$refs.savedMonies.loadData()
        })
      },
      viewLastMonthInstallments () {
        this.dialogLastMonthInstallments = true
        this.$nextTick(() => {
          this.$refs.installments.loadData()
        })
      },
      viewThisMonthCheckoutedMembers () {

      },
      viewCheckoutedMembers () {

      },
    },
  }
</script>
<style>
svg.ct-chart-bar, svg.ct-chart-line{
    overflow: visible;
}
.ct-label.ct-label.ct-horizontal.ct-end {
  position: relative;
  justify-content: flex-end;
  text-align: right;
  transform-origin: 100% 0;
  transform: translate(-100%) rotate(-45deg);
  white-space:nowrap;
}
.ct-label.ct-vertical.ct-start{
  white-space: pre;
  transform: translateX(-5px);
}
</style>
